import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AngularModule } from '../../../../modules/angular.module';
import { ZorroModule } from '../../../../modules/zorro.module';
import { EmailName, Section, UserAndEmail, UserSection } from '@mira-avant/mtlibs';
import { UserService } from '../../../../services/user.service';

@Component({
	selector: 'app-review-users-sections-table',
	standalone: true,
	imports: [AngularModule, ZorroModule],
	templateUrl: './review-users-sections-table.component.html',
	styleUrl: './review-users-sections-table.component.scss',
})
export class ReviewUsersSectionsTableComponent {
	@Output('onFinished') public onFinished: EventEmitter<void> = new EventEmitter<void>();
	@Input('emails') public emails: EmailName[] = [];
	public usersAndEmails: UserAndEmail[] = [];
	public checked = false;
	public indeterminate = false;
	public selectedEmails = new Set<string>();

	constructor(private userService: UserService) {}

	ngOnInit(): void {
		this.userService
			.getUsersAndSections(this.emails.map(email => email.email))
			.then((usersAndEmails: UserAndEmail[]) => {
				this.usersAndEmails = usersAndEmails;
			});
	}

	public updateCheckedSet(email: string, checked: boolean): void {
		if (checked) {
			this.selectedEmails.add(email);
		} else {
			this.selectedEmails.delete(email);
		}
	}

	public refreshCheckedStatus(): void {
		this.checked = this.usersAndEmails.every(({ email }) => this.selectedEmails.has(email));
		this.indeterminate =
			this.usersAndEmails.some(({ email }) => this.selectedEmails.has(email)) &&
			!this.checked;
	}

	public onItemChecked(email: string, checked: boolean): void {
		this.updateCheckedSet(email, checked);
		this.refreshCheckedStatus();
	}

	public onAllChecked(checked: boolean): void {
		this.usersAndEmails.forEach(({ email }) => this.updateCheckedSet(email, checked));
		this.refreshCheckedStatus();
	}

	public prettySections(userSections: UserSection[]): string {
		return userSections.map(us => us.section?.name + ' - ' + us.section?.language).join(', ');
	}

	public clearSectionsFromSelectedUsers(): void {
		const selectedEmailsAsArray: string[] = Array.from(this.selectedEmails);

		this.userService.removeUsersSections(selectedEmailsAsArray).then(() => {
			this.usersAndEmails = this.usersAndEmails.filter(
				({ email }) => !selectedEmailsAsArray.includes(email)
			);

			this.selectedEmails.clear();
			this.refreshCheckedStatus();
		});
	}

	public continue(): void {
		this.onFinished.emit();
	}
}
